import moment from "moment";
import React, { useState } from "react";
import { PIFlowLeftNavBar } from "../../ReusableComp/NavBarLeft";
import NavigationBar from "../../ReusableComp/NavigationBar";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
    base_url,
    SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT,
    SUBJECT_STATUS_ON_STUDY,
    SUBJECT_STATUS_OFF_STUDY,
    EVENT_CLASSIFICATION_AESI,
    EVENT_CLASSIFICATION_LEVEL_BRIGHTON,
    EVENT_CLASSIFICATION_GRADE_CTCAE,
    EVENT_CLASSIFICATION_OTHER,
    PRINCIPAL_INVESTIGATOR,
    EVENT_STATUS_REVIEWED,
    EVENT_STATUS_SENT_BACK_FOR_REVIEW
} from "../../../utilities";
import axios from "../../../axios-interceptor";
import PopUpModal from "../../ReusableComp/PopUpModal";
import {
    getEventDetails,
    getSAdvEvents,
    getStudyAeDetailsSimplified,
    getAllCausalities,
    getAllOutComes,
    getActionTaken,
    getActionTakenForAE,
    getReviewerComments,
    resetEventDetails
} from '../../../Redux/actions/actions';
import { useEffect } from "react";
import { useLocation } from 'react-router';
import Loader from '../../ReusableComp/Loader'; // Import the Loader component
import BrightonCase from '../SubjectFlow/BrightonCase';
import GradeCase from '../SubjectFlow/GradeCase';
import { FaEye, FaDownload, FaTimes } from 'react-icons/fa';
import { Modal, Button } from 'react-bootstrap';
import BrightonCaseUpdateAE from "../SubjectFlow/BrightonCaseUpdateAE";
import GradeCaseUpdateAE from "../SubjectFlow/GradeCaseUpdateAE";

const UpdateAEDetails = () => {
    const navigate = useNavigate()
    const eventDtls = useSelector((state) => state.eventDtls)
    const subjDetails = useSelector((state) => state.getSubProf)
    const causalities = useSelector((state) => state.getCausalities);
    const outComes = useSelector((state) => state.getOutComes);
    const actnTakenOpts = useSelector((state) => state.actionTaken);
    const actionTakenforAe = useSelector((state) => state.actionTakenforAe);
    const saEvents = useSelector((state) => state.getSAEvents);
    const getStudyAeDtls = useSelector((state) => state.getStudyAeDtls)
    const reviewerComments = useSelector((state) => state.reviewerComments);
    const dispatch = useDispatch();
    const location = useLocation();
    const JustBtwn = "d-flex justify-content-between";
    const [searchTerm, setSearchTerm] = useState("");
    const [btnTitle, setBtnTitle] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [seriousAE, setSeriousAE] = useState({});
    const [notesChange, setNotesChange] = useState("");
    const [radioValue, setRadioValue] = useState("")
    const [radioReset, setRadioReset] = useState('')
    const [eventDesc, setEventDesc] = useState()
    const [treatmentGiven, setTreatmentGiven] = useState("")
    const [valuForDisble, setValuForDisble] = useState()
    const [defaultValues, setDefaultValues] = useState({})
    const [loading, setLoading] = useState(true);
    const[loader,setLoader] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [flag, setFlag] = useState(true);
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [actionAdverse, setActionAdverse] = useState("Select");
    const [selectedOption, setSelectedOption] = useState('Select');
    const subjectProfile = useSelector((state) => state.getSubProf);
    let extensions=""
    const [buttonDisable,setButtonDisable] = useState(false)

    useEffect(() => {
        async function fetchData() {
            try {
                setLoading(true)
                dispatch(getEventDetails({ adverse_event_id: location.state.adverse_event_mapping_id }))
                dispatch(getReviewerComments({
                    adverse_event_mapping_id: location.state.adverse_event_mapping_id
                }))
                dispatch(getSAdvEvents())
                dispatch(getAllCausalities())
                dispatch(getAllOutComes())
                dispatch(getActionTaken())
                dispatch(getActionTakenForAE())
            } catch (error) {
                console.log(error)
            }
        };
        fetchData()
    }, [dispatch]);
    useEffect(() => {
        if (eventDtls) {
            dispatch(getStudyAeDetailsSimplified({
                case_def: eventDtls?.study_case_definition,
                value: eventDtls?.study_aebank_id
            }));
            setDefaultValues({
                dateOfOnset: eventDtls?.date_of_onset,
                dateOfResolution: eventDtls?.date_of_resolution,
                timeOfOnset: eventDtls?.time_of_onset,
                start_date_of_treatment: eventDtls?.start_date_of_treatment,
                end_date_of_treatment: eventDtls?.end_date_of_treatment,
                timeOfResolution: eventDtls?.time_of_resolution,
                causality_id: eventDtls?.causality_id,
                outcome_id: eventDtls?.outcome_id,
                action_taken_for_adverse_event_id: eventDtls?.action_taken_for_adverse_event_id,
                action_taken_id: eventDtls?.action_taken_id
            });
            if (eventDtls?.action_taken_for_adverse_event_name === "Surgical Treatment" ||
                eventDtls?.action_taken_for_adverse_event_name === "Medical Treatment") {
                setFlag(false);
            }
            else {
                setFlag(true);
            }
            setNotesChange(eventDtls?.input_notes_aesi_others);
            setRadioValue(eventDtls?.event_description_id);
            setLoading(false)

//getting the documents 
const fetchImages = async () => {
      const updatedStudies = await Promise.all(
        eventDtls?.documents.map(async (elem) => {
          if (elem.document_url != null && elem.document_url !== '') {
            const queryParams = `?url=${elem.document_url}`;
            const response = await fetch(base_url + 'api/getImage' + queryParams);
            const data = await response.arrayBuffer();
            const base64 = btoa(new Uint8Array(data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            elem.image_url = `data:${response.headers.get('content-type')};base64,${base64}`;
            return elem;
          } else {
            return elem;
          }
        })
      );

     // setFilteredStudies(updatedStudies);
  };

  fetchImages();
        }
    }, [eventDtls])

    const downloadFile = (fileUrl,typeOfDoc,document_name) => {
        const validDocumentTypes = ["doc", "pdf", "docx", "txt", "ppt", "xls", "xlsx"];
        if (validDocumentTypes.includes(typeOfDoc)) {
        fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
    // Create a Blob from the binary data
    const blobUrl = window.URL.createObjectURL(blob);

    // Create a download link and trigger a click event
    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    downloadLink.download = document_name; // Set the desired file name
    downloadLink.click();

    // Clean up the URL.createObjectURL
    window.URL.revokeObjectURL(blobUrl);
  })
  .catch(error => {
    console.error('Error fetching file:', error);
  });
}
else{
  fetch(fileUrl)
  .then(response => response.blob())
  .then(blob => {
    // Create a Blob from the binary data
    const blobUrl = window.URL.createObjectURL(blob);
    // Create a download link and trigger a click event
    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    // Set the appropriate file extension based on the image type
    const extension = typeOfDoc === 'jpeg' ? 'jpg' : typeOfDoc;
    downloadLink.download = document_name;
    downloadLink.click();
    // Clean up the URL.createObjectURL
    window.URL.revokeObjectURL(blobUrl);
})
}
}
    const [open, setOpen] = React.useState(false);
    const minDateofOnset = subjDetails && subjDetails["SubjectDoses.date_of_administration"]
    const [today, setToday] = useState('');

    useEffect(() => {
        const currentDate = new Date();
        const formattedDate = currentDate.toDateString();
        setToday(formattedDate);
    }, [today]);

    // let status = `${subjDetails['SubjectDoses.status']}`
    let status = subjDetails?.SubjectDoses?.status || '';
    const myArray = [
        {
            title: subjDetails && subjDetails['Study.study_name'],
            description: "Study",
        },
        {
            description: "Dose",
            title: subjDetails && `D${subjDetails['SubjectDoses.dose']}`,
        },
        {
            title: subjDetails && subjDetails['PrincipalInvestigator.name'],
            description: "Principal Investigator",
        },
        {
            id: 4, description: "Status", title:
                status == SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT ? 'On going adverse event' :
                    status == SUBJECT_STATUS_ON_STUDY ? 'On study' :
                        status == SUBJECT_STATUS_OFF_STUDY ? 'Concluded study' : ''
        }
    ];

    const getRoleCode = (data) => { };

    const handleBack = () => {
        dispatch(resetEventDetails())
        navigate('/pisubjectslist', {
            state: {
                data: 2,
            }
        })
    }
    const handleTreatment = (e) => {
        let value = e.target.value;
        if (value !== '') { setTreatmentGiven(value) }
        else { setTreatmentGiven('') }

    }

    const handleDefaultValuesChange = e => {
        const { name, value } = e.target;
        const selectedValue = e.target.value;
        if (selectedValue === "Select") {
            setFlag(true);
        }
        setSelectedOption(selectedValue);
        for (var i = 0; i < actionTakenforAe.length; i++) {
            var currentObject = actionTakenforAe[i];
            if (currentObject.action_taken_for_adverse_event_id === selectedValue) {
                setActionAdverse(currentObject.action_taken_for_adverse_event_name)
                if (currentObject.action_taken_for_adverse_event_name === "None") {
                    setFlag(true);
                    setButtonDisable(false)
                    setDefaultValues({...defaultValues,start_date_of_treatment:null,end_date_of_treatment:null})
                }
                else {
                    setButtonDisable(true)
                    setFlag(false)
                }
            }
        }
        setDefaultValues(prev => ({
            ...prev,
            [name]: value,
        }))
        if (name === 'timeOfOnset' || name === 'dateOfOnset') {
            setDefaultValues((prevValues) => ({
                ...prevValues,
                dateOfResolution: '',
                timeOfResolution: '',
            }));
        }

        if(name === "dateOfResolution"){
            setDefaultValues((prevValues) => ({
                ...prevValues,
                // dateOfResolution: '',
                timeOfResolution: '',
            }));

        }
    }

    const handleNotesChange = (e) => {
        setNotesChange(e.target.value)
    }

    const handleReset = () => {
        setRadioReset('')
    }

    function getEventDescId(val) {
        if (val) {
            setEventDesc(val)
            setValuForDisble(val)
        }
    }

    function handleRadioBtn(val) {
        setRadioValue(val)
    }

    function handleConfirm() {
        window.location.replace("/pisubjectslist")
    }

    const handleClosePopup = () => {
        setOpen(false);
        window.location.reload();
    };

    function handleSearch(e) {
        setSearchTerm(e.target.value);
    }

    function handleOption(e) {
        setSearchTerm(e.serious_adverse_event_name);
        setShowPopup(false)
        setBtnTitle(e.serious_adverse_event_name)
        setSeriousAE({
            label: e.serious_adverse_event_name,
            value: e.serious_adverse_event_id,
        })
    }

    function handleDropDown() {
        setShowPopup(!showPopup)
        setSearchTerm('');

    }
    
    const handleUpdate =  () => {
        setLoader(true)
        let updateObj = {
            "pi_id": localStorage.pi_id,
            "adverse_event_mapping_id": eventDtls?.adverse_event_mapping_id,
            "date_of_onset": defaultValues.dateOfOnset,
            "time_of_onset": defaultValues.timeOfOnset,
            "start_date_of_treatment": defaultValues.start_date_of_treatment,
            "end_date_of_treatment": defaultValues.end_date_of_treatment,
            "date_of_resolution": defaultValues.dateOfResolution,
            "time_of_resolution": defaultValues.timeOfResolution,
            "causality_id": defaultValues.causality_id,
            "outcome_id": defaultValues.outcome_id,
            "action_taken_id": defaultValues.action_taken_id,
            "action_taken_for_adverse_event_id": defaultValues.action_taken_for_adverse_event_id,
            "event_description_id": eventDesc?.event_description_id || null,
            "is_case_meets": eventDesc?.is_case_meets || null,
            "any_treatment_given": treatmentGiven,
            "input_notes_aesi_others": notesChange,
            "serious_adverse_event_id": seriousAE.value,
            "subject_id":subjDetails?.subject_id,
            "updated_by": localStorage.login_user_name           
        }
        const formData = new FormData();

        // Append each property to the FormData
        for (const key in updateObj) {
          if (updateObj[key] !== null)
            formData.append(key, updateObj[key]);
        }
        for (let i = 0; i < file.length; i++) {
          formData.append('files', file[i]);
        }
        axios
            .post(base_url + "principal-investigator/update_adverse_event", formData,{
            headers: {
                'Content-Type': 'multipart/form-data'
              }})
        
            .then((res) => {
                if (res.data.data.errors) {
                    if (res.data.data.errors[0].message) {
                        toast.error(`${res.data.data.errors[0].message}`, {
                            toastId: 2
                        })
                    }
                }
                else {
                    setOpen(true);
                }
            // })
            // .catch((err) => {
            //     console.log(err);
            // });
        })
        .catch((err) => {
          // Handle errors if any
        })
        .finally(() => {
          setLoader(false); // Set loader back to false after the API call completes
        });
    }
   


    const cleanText =
        eventDtls?.study_case_definition === EVENT_CLASSIFICATION_AESI ? eventDtls?.input_notes_aesi_others :
            eventDtls?.study_case_definition === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? eventDtls?.study_event_meets_case_definition || eventDtls.study_event_doesnt_meets_case_definition :
                eventDtls?.study_case_definition === EVENT_CLASSIFICATION_GRADE_CTCAE ? eventDtls?.study_ctcae_definition :
                    eventDtls?.study_case_definition === EVENT_CLASSIFICATION_OTHER ? eventDtls?.input_notes_aesi_others : ''
        ;

    const disableFields = eventDtls?.qr_event_status === EVENT_STATUS_REVIEWED ? true : false

    const handleViewClick = (document) => {   
        setSelectedDocument(document);        
    };
    function calculateBMI(weight, height) {
        if (isNaN(weight) || isNaN(height) || height === null) {
            return "0"; // Display "N/A" if either weight or height is not a number
        }
        const bmi = weight / ((height / 100) ** 2);

        return bmi.toFixed(1);
    }


    // Handle Start Date change
    const handleStartDateChange = (e) => {
        const newStartDate = e.target.value;
        setDefaultValues({
            ...defaultValues,
            start_date_of_treatment: newStartDate,
            end_date_of_treatment: "",
        });
    };


    // Handle End Date change
    const handleEndDateChange = (e) => {
        const newEndDate = e.target.value;
        setDefaultValues({
            ...defaultValues,
            end_date_of_treatment: newEndDate,
        });
    };

    function getIcon(fileExtension) {
        switch (fileExtension) {
            case 'pdf':
                return "./images/icons/reshot-icon-pdf.svg"
            case 'ppt':
                return "./images/icons/reshot-icon-ppt.svg"
            case 'txt':
                return "./images/icons/reshot-icon-txt.svg"
            case 'docx':
                return "./images/icons/reshot-icon-docx.svg"
            case 'doc':
                return "./images/icons/reshot-icon-doc.svg"
            case 'xls':
                return "./images/icons/reshot-icon-xls.svg"
            case 'csv':
                return "./images/icons/reshot-icon-csv.svg"
            case 'jpg':
                return "./images/icons/reshot-icon-jpg.svg"
            case 'png':
                return "./images/icons/reshot-icon-png.svg"
            case 'jpeg':
                return "./images/icons/reshot-icon-jpeg.svg"
            case 'xlsx':
                return "./images/icons/excel-svgrepo-com.svg"
        }
    }
    const handleOpenModal = (document) => {
        setSelectedDocument(document);
      };
    
      
      const handleCloseModal = () => {
        setSelectedDocument(null);
      };
      const isImage = (url) => {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
        return imageExtensions.includes(url);
      };

      const [timeError, setTimeError] = useState("");
  const [showTimeError, setShowTimeError] = useState(false)

  function validateTimeOfResolution(event) {
    const inputTime = event.target.value;
    const timeOfOnset = defaultValues.timeOfOnset;
  
    if (timeOfOnset) {
      // Convert input times to minutes for comparison
      const inputTimeMinutes = timeStringToMinutes(inputTime);
      const timeOfOnsetMinutes = timeStringToMinutes(timeOfOnset);
  
      if (inputTimeMinutes < timeOfOnsetMinutes) {
        const val = "Select time after "+defaultValues.timeOfOnset
        setTimeError(val)
        setShowTimeError(true)
        // If the input time is before the time of onset, clear the input
        event.target.value = '';
      }
      else{
        setTimeError("val")
        setShowTimeError(false)
      }
    }
  }
  
  
  function timeStringToMinutes(timeString) {
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  }
      
    const [fileNames, setFileNames] = useState([]);
    const [file, setFile] = useState([]);

    const handleRemoveFile = (index) => {
        setFileNames((prevFileNames) => {
          const newFileNames = [...prevFileNames];
          newFileNames.splice(index, 1);
          return newFileNames;
        });
        setFile((prevFileNames) => {
          const newFileNames = [...prevFileNames];
          newFileNames.splice(index, 1);
          return newFileNames;
        });
      };

      const handleDrop = (event) => {
        event.preventDefault(); // Prevent automatic preview
        if (event.dataTransfer.items) {
          const files1 = event.dataTransfer.items;
          const fileList = Array.from(files1).map((item) => item.getAsFile());
          const maxIndividualFileSize = 10 * 1024 * 1024; // 10MB in bytes
          const maxCombinedFileSize = 30 * 1024 * 1024; // 30MB in bytes
          const maxFiles = 3; // Maximum allowed files
          const files = Array.from(fileList);
          const totalSize = files.reduce((acc, file) => acc + file.size, 0);
          if(file.length<3){
          if (files.length > maxFiles) {
            toast.error(`You can upload a maximum of ${maxFiles} files`, {
              toastId: 9,
            });
          } else if (
            files.every((file) => file.size <= maxIndividualFileSize) &&
            totalSize <= maxCombinedFileSize
          ) {
            const newFileNames = files.map((file) => file.name);
            const newFile = files;
            setFile((prevFile) => [...prevFile, ...newFile]);
            setFileNames((prevFileNames) => [...prevFileNames, ...newFileNames]);
          } else {
            if (!files.every((file) => file.size <= maxIndividualFileSize)) {
              toast.error("File size should be less than 10 MB", {
                toastId: 7,
              });
            }
          }
        }
          else{
            toast.error(`You can upload a maximum of ${maxFiles} files`, {
              toastId: 9,
            });
          }
      }
      };

      const handleDragOver = (event) => {
        event.preventDefault();
    };
    const handleFileUpload = (event) => {
        const maxIndividualFileSize = 10 * 1024 * 1024; // 10MB in bytes
        const maxCombinedFileSize = 30 * 1024 * 1024; // 30MB in bytes
        const maxFiles = 3; // Maximum allowed files
      
        const files = Array.from(event.target.files);
        const totalSize = files.reduce((acc, file) => acc + file.size, 0);
       
        if (files.length > maxFiles) {
          toast.error(`You can upload a maximum of ${maxFiles} files`, {
            toastId: 9,
          });
        } else if (files.every((file) => file.size <= maxIndividualFileSize) && totalSize <= maxCombinedFileSize) {
          const newFileNames = files.map((file) => file.name);
          const newFile = files;
          setFile((prevFile) => [...prevFile, ...newFile]);
          setFileNames((prevFileNames) => [...prevFileNames, ...newFileNames]);
        } else {
          if (!files.every((file) => file.size <= maxIndividualFileSize)) {
            toast.error("File size should be less than 10 MB", {
              toastId: 7,
            });
          }
          
        }
      };


    return (
        <>
            {/* {loading && <Loader />} */}
            {loading ? (
                <div className=''>
                    <img
                        className="atrium_loader1"
                        src="/images/circle-effect-loading.gif"
                        alt="Loader"

                    />
                </div>
            ) :
                <div>
                    <NavigationBar studyDropdwn={true}
                        title={'Update Adverse Event'}
                        rolecode={getRoleCode}
                    />
                    {/* <PIFlowLeftNavBar /> */}
                    <div className="main_body ">
                        <Container fluid className="p-0">
                            <Row className="SVdtl_Main custm_pdng_aedtls ">
                                <div className="section_1 col-lg-4">
                                    {subjDetails && <div className="pisubj_left_main">
                                        <div className="review_min_high review_min_highmbl">
                                            <div className="p-3 body_cls s2 studydtlsmbl">
                                                <h6 className="mb-0">
                                                    {subjDetails?.first_name}
                                                    {" " + subjDetails?.last_name}
                                                </h6>

                                                <span>

                                                    <h6>{subjDetails?.subject_code}</h6></span>

                                                <div className="row">
    <div className="col-6 p-0">
        <div className="mb-0">
            <span className="mb-0">Age:</span> <span className="space_yrs highlet-left">{subjectProfile?.age} Yrs</span>
        </div>
    </div>
    <div className="col-6">
        <div className="mb-0">
            <span className="mb-0">Height:</span> <span className='space_height highlet-left'>{subjectProfile?.height ? subjectProfile.height : 0} cm</span>
        </div>
    </div>
</div>
<div className="row">
    <div className="col-6 p-0">
        <div className="mb-0">
            <span className="mb-0">Gender:</span> <span className='highlet-left'>{subjectProfile?.sex}</span>
        </div>
    </div>
    <div className="col-6">
        <div className="mb-0">
            <span className="mb-0">Weight:</span> <span className='highlet-left'>{subjectProfile?.weight}Kg</span>
        </div>
    </div>
</div>
<div className="row">
    <div className="col-12 p-0">
        <div className="mb-0">
            <span className="mb-0">BMI:</span> <span className="space_bmi highlet-left">{calculateBMI(subjectProfile?.weight, subjectProfile?.height)} (BMI)</span>
        </div>
    </div>
</div>

                                                <span className="d-flex justify-content-between w-100">

                                                    <h6 className="site_add">
                                                        {subjDetails['Site.site_address']}
                                                    </h6>
                                                    <img
                                                        className=""
                                                        src="./images/icons/location.svg"
                                                        alt="Location Icon"
                                                    />
                                                </span>
                                            </div>
                                            <div className="px-3 s2 studydtlsmbl ">
                                                {myArray.map((i, index) => {
                                                    return (
                                                        <div className=
                                                            {`${window.screen.width <= 720 ? 'studytabmbl' : "studytab"}`}
                                                            key={index}>
                                                            <span className="text-end">{i.title}</span>
                                                            <span className="study_tab_desc">
                                                                {i.description}
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>}
                                </div>

                                <div className="col review_event_header pisub">
                                    <div className='title_cls right_cntnt right_cntntmbl'>
                                        <h5 className="mb-1">Event {
                                            disableFields ? <span style={{ marginLeft: "5px", color: "red", fontSize: "18px" }}>(Note : You are not allowed to edit this event, as this event has already been reviewed by a quality reviewer)</span> : ""
                                        }</h5>
                                    </div>

                                    <Col className=" py-1 px-md-4 py-md-3 qr_right_content">
                                        <div className="dispblock px-3">

                                            <div className="">
                                                <label htmlFor="dateOfonSet" className="custm_label_fw">
                                                    Date of onset
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    value={defaultValues.dateOfOnset}
                                                    disabled={disableFields}
                                                    className="customInput custminputbml"
                                                    id="dateOfOnset"
                                                    type="date"
                                                    name="dateOfOnset"
                                                    min={minDateofOnset}
                                                    max={moment(today).format("YYYY-MM-DD")}
                                                    placeholder="Enter Here"
                                                    aria-placeholder="#D4D4D4"
                                                    style={{
                                                        padding: "16px 12px",
                                                        width: "340px",
                                                        cursor: "not-allowed",
                                                    }}
                                                    onChange={handleDefaultValuesChange}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                                {defaultValues.dateOfOnset?null:
                                                    <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                                                    }
                                            </div>
                                           
                                            <div className="">
                                                <label htmlFor="timeOfonSet" className="custm_label_fw">
                                                    Time of onset (24 Hrs)
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    value={defaultValues.timeOfOnset}
                                                    disabled={disableFields}
                                                    className="customInput custminputbml"
                                                    id="timeOfOnset"
                                                    type="time"
                                                    name="timeOfOnset"
                                                    placeholder="Enter Here"
                                                    aria-placeholder="#D4D4D4"
                                                    style={{ padding: "16px 12px", width: "340px" }}
                                                    onChange={handleDefaultValuesChange}
                                                />
                                                {defaultValues.timeOfOnset?null:
                                                    <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                                                    }
                                            </div>
                                        </div>
                                        <div className="dispblock px-3">
                                            <div className="">
                                                <label
                                                    htmlFor="dateOfResolution"
                                                    className="custm_label_fw"
                                                >
                                                    Date of resolution
                                                </label>
                                                <input
                                                    value={defaultValues.dateOfResolution}
                                                    disabled={disableFields}
                                                    className="customInput custminputbml"
                                                    id="dateOfResolution"
                                                    name="dateOfResolution"
                                                    min={defaultValues.dateOfOnset}
                                                    max={moment(today).format("YYYY-MM-DD")}
                                                    type="date"
                                                    placeholder="Enter Here"
                                                    aria-placeholder="#D4D4D4"
                                                    style={{
                                                        padding: "16px 12px",
                                                        width: "340px",
                                                        cursor: "not-allowed",
                                                    }}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    onChange={handleDefaultValuesChange}
                                                />
                                                {defaultValues.dateOfResolution?null:
                                                    <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                                                    }
                                            </div>
                                            {defaultValues.dateOfOnset === defaultValues.dateOfResolution ?
                                                <div className="">
                                                <label htmlFor="lastName" className="custm_label_fw">
                                                    Time of resolution (24 Hrs)
                                                </label>
                                                <input
                                                    value={defaultValues.timeOfResolution}
                                                    disabled={disableFields}
                                                    className="customInput custminputbml"
                                                    id="timeOfResolution"
                                                    name="timeOfResolution"
                                                    type="time"
                                                    placeholder="Enter Here"
                                                    aria-placeholder="#D4D4D4"
                                                    style={{ padding: "16px 12px", width: "340px" }}
                                                    onChange={handleDefaultValuesChange}
                                                    min={defaultValues.timeOfOnset}
                                                    onInput={validateTimeOfResolution}
                                                    />
                                                    {defaultValues.timeOfResolution?null:
                                                    <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                                                    }
                                                    <span style={{color:"red", fontSize:"14px"}}>
                                                      {showTimeError? timeError : null}
                                                    </span>
                                            </div>
                                            :
                                            <div className=" ">
                                                <label htmlFor="lastName" className="custm_label_fw">
                                                    Time of resolution (24 Hrs)  {defaultValues.dateOfResolution && <span style={{ color: "red" }}>*</span> }
                                                </label>
                                                <input
                                                    value={defaultValues.timeOfResolution}
                                                    disabled={disableFields}
                                                    className="customInput custminputbml"
                                                    id="timeOfResolution"
                                                    name="timeOfResolution"
                                                    type="time"
                                                    placeholder="Enter Here"
                                                    aria-placeholder="#D4D4D4"
                                                    style={{ padding: "16px 12px", width: "340px" }}
                                                    onChange={handleDefaultValuesChange}
                                                />
                                                {defaultValues.timeOfResolution?null:
                                                    <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                                                    }
                                            </div>

                                            }
                                            
                                        </div>
                                        <div className={`d-md-flex d-lg-flex d-xxl-flex d-none flex-column gap-3 border p-3 rounded `}>

                                            <div className="coaadrpdnsdsk">
                                                <div >
                                                    <label htmlFor="causality">
                                                        Causality
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <div className="custom_select_main">
                                                        <select
                                                            value={defaultValues.causality_id}
                                                            disabled={disableFields}
                                                            className="selectTag"
                                                            id="lastName"
                                                            type="text"
                                                            name='causality_id'
                                                            style={{ padding: "16px 12px", width: "340px" }}
                                                            onChange={handleDefaultValuesChange}
                                                        >
                                                            <option value={"Select"}>{eventDtls?.causality_name}</option>
                                                            {causalities &&
                                                                causalities.map((i) => {
                                                                    return (
                                                                        <option
                                                                            key={i.causality_id}
                                                                            value={i.causality_id}
                                                                        >
                                                                            {i.causality_name}
                                                                        </option>
                                                                    );
                                                                })}
                                                        </select>
                                                    </div>

                                                </div>
                                                <div >
                                                    <label htmlFor="outCome">
                                                        Outcome
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <div className="custom_select_main">
                                                        <select
                                                            value={defaultValues.outcome_id}
                                                            disabled={disableFields}
                                                            className="selectTag"
                                                            id="lastName"
                                                            type="text"
                                                            name='outcome_id'
                                                            style={{ padding: "16px 12px", width: "340px" }}
                                                            onChange={handleDefaultValuesChange}
                                                        >
                                                            <option value={"Select"}>
                                                                {eventDtls?.outcome_name}
                                                            </option>
                                                            {outComes &&
                                                                outComes.map((i) => {
                                                                    return (
                                                                        <option value={i.outcome_id} key={i.outcome_id}>
                                                                            {i.outcome_name}
                                                                        </option>
                                                                    );
                                                                })}
                                                        </select>
                                                    </div>

                                                </div>

                                            </div>
                                            <div className="  coaadrpdnsdsk">
                                                <div >
                                                    <label htmlFor="actionTaken">
                                                        Action Taken For Study Vaccine
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <div className="custom_select_main">
                                                        <select
                                                            value={defaultValues.action_taken_id}
                                                            disabled={disableFields}
                                                            className="selectTag"
                                                            id="lastName"
                                                            type="text"
                                                            name='action_taken_id'
                                                            style={{ padding: "16px 12px", width: "340px" }}
                                                            onChange={handleDefaultValuesChange}
                                                        >
                                                            <option value={"Select"}>{eventDtls?.action_taken_name}</option>
                                                            {actnTakenOpts &&
                                                                actnTakenOpts.map((i) => {
                                                                    return (
                                                                        <option
                                                                            key={i.action_taken_id}
                                                                            value={i.action_taken_id}
                                                                        >
                                                                            {i.action_taken_name}
                                                                        </option>
                                                                    );
                                                                })}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div >
                                                    <label htmlFor="actionTaken">
                                                        Action Taken For Adverse Event
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <div className="custom_select_main">
                                                        <select
                                                            value={defaultValues.action_taken_for_adverse_event_id}
                                                            disabled={disableFields}
                                                            className="selectTag"
                                                            id="lastName"
                                                            type="text"
                                                            name='action_taken_for_adverse_event_id'
                                                            style={{ padding: "16px 12px", width: "340px" }}
                                                            onChange={handleDefaultValuesChange}
                                                        >
                                                            <option value={"Select"}>
                                                                {eventDtls?.action_taken_for_adverse_event_name}
                                                            </option>
                                                            {actionTakenforAe &&
                                                                actionTakenforAe.map((i) => {
                                                                    return (
                                                                        <option value={i.action_taken_for_adverse_event_id} key={i.action_taken_for_adverse_event_id}>
                                                                            {i.action_taken_for_adverse_event_name}
                                                                        </option>
                                                                    );
                                                                })}
                                                        </select>
                                                    </div>
                                                </div>


                                            </div>

                                            <div className="d-flex justify-content-between ">
                                                {/* Start Date input */}
                                                {flag !== true && (

                                                    <div className="start-end-date">
                                                        <label htmlFor="startDate" className="custm_label_fw">
                                                            <p className="adverse-auto">Treatment Start Date{defaultValues.dateOfResolution && <span className="text-danger">*</span>}</p>
                                                        </label>
                                                        <input
                                                            value={defaultValues?.start_date_of_treatment}
                                                            className="custminputbml selectTag"
                                                            id="start_date_of_treatment"
                                                            type="date"
                                                            placeholder="Enter Start Date"
                                                            aria-placeholder="#D4D4D4"
                                                            style={{ padding: "16px 12px", width: "340px" }}
                                                            onChange={handleStartDateChange}
                                                        />
                                                    </div>
                                                )}



                                                {/* End Date input */}
                                                {flag !== true && (

                                                    <div className="start-end-date">
                                                        <label htmlFor="endDate" className="custm_label_fw">
                                                            <p className="adverse-auto">Treatment End Date{defaultValues.dateOfResolution && <span className="text-danger">*</span>}</p>
                                                        </label>
                                                        <input
                                                            value={defaultValues?.end_date_of_treatment}
                                                            className="custminputbml selectTag"
                                                            id="end_date_of_treatment"
                                                            type="date"
                                                            placeholder="Enter End Date"
                                                            aria-placeholder="#D4D4D4"
                                                            style={{ padding: "16px 12px", width: "340px" }}
                                                            onChange={handleEndDateChange}
                                                            min={defaultValues.start_date_of_treatment} // Set minimum date based on Start Date
                                                        />
                                                    </div>
                                                )}

                                            </div>

                                        </div>


                                        {/* ////////////////////// */}

                                        <div className="coaadrpdnsdmbl">
                                            <label htmlFor="causality">
                                                Causality
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <div className="custom_select_main">
                                                <select
                                                    value={defaultValues.causality_id}
                                                    disabled={disableFields}
                                                    className="selectTag"
                                                    id="lastName"
                                                    type="text"
                                                    name='causality_id'
                                                    style={{ padding: "16px 12px", width: "340px" }}
                                                    onChange={handleDefaultValuesChange}
                                                >
                                                    <option value={"Select"}>{eventDtls?.causality_name}</option>
                                                    {causalities &&
                                                        causalities.map((i) => {
                                                            return (
                                                                <option
                                                                    key={i.causality_id}
                                                                    value={i.causality_id}
                                                                >
                                                                    {i.causality_name}
                                                                </option>
                                                            );
                                                        })}
                                                </select>
                                            </div>

                                        </div>
                                        <div className="coaadrpdnsdmbl">
                                            <label htmlFor="outCome">
                                                Outcome
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <div className="custom_select_main">
                                                <select
                                                    value={defaultValues.outcome_id}
                                                    disabled={disableFields}
                                                    className="selectTag"
                                                    id="lastName"
                                                    type="text"
                                                    name='outcome_id'
                                                    style={{ padding: "16px 12px", width: "340px" }}
                                                    onChange={handleDefaultValuesChange}
                                                >
                                                    <option value={"Select"}>
                                                        {eventDtls?.outcome_name}
                                                    </option>
                                                    {outComes &&
                                                        outComes.map((i) => {
                                                            return (
                                                                <option value={i.outcome_id} key={i.outcome_id}>
                                                                    {i.outcome_name}
                                                                </option>
                                                            );
                                                        })}
                                                </select>
                                            </div>

                                        </div>



                                        <div className="coaadrpdnsdmbl">
                                            <label htmlFor="actionTaken">
                                                Action Taken For Study Vaccine
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <div className="custom_select_main">
                                                <select
                                                    value={defaultValues.action_taken_id}
                                                    disabled={disableFields}
                                                    className="selectTag"
                                                    id="lastName"
                                                    type="text"
                                                    name='action_taken_id'
                                                    style={{ padding: "16px 12px", width: "340px" }}
                                                    onChange={handleDefaultValuesChange}
                                                >
                                                    <option value={"Select"}>{eventDtls?.action_taken_name}</option>
                                                    {actnTakenOpts &&
                                                        actnTakenOpts.map((i) => {
                                                            return (
                                                                <option
                                                                    key={i.action_taken_id}
                                                                    value={i.action_taken_id}
                                                                >
                                                                    {i.action_taken_name}
                                                                </option>
                                                            );
                                                        })}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="coaadrpdnsdmbl">
                                            <label htmlFor="actionTaken">
                                                Action Taken For Adverse Event
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <div className="custom_select_main">
                                                <select
                                                    value={defaultValues.action_taken_for_adverse_event_id}
                                                    disabled={disableFields}
                                                    className="selectTag"
                                                    id="lastName"
                                                    type="text"
                                                    name='action_taken_for_adverse_event_id'
                                                    style={{ padding: "16px 12px", width: "340px" }}
                                                    onChange={handleDefaultValuesChange}
                                                >
                                                    <option value={"Select"}>
                                                        {eventDtls?.action_taken_for_adverse_event_name}
                                                    </option>
                                                    {actionTakenforAe &&
                                                        actionTakenforAe.map((i) => {
                                                            return (
                                                                <option value={i.action_taken_for_adverse_event_id} key={i.action_taken_for_adverse_event_id}>
                                                                    {i.action_taken_for_adverse_event_name}
                                                                </option>
                                                            );
                                                        })}
                                                </select>
                                            </div>


                                            {/* Start Date input */}
                                            {flag !== true && (
                                                <div className="start-end-date">
                                                    <label htmlFor="startDate" className="custm_label_fw start-date">
                                                        <p className="adverse-auto">Treatment Start Date
                                                        {defaultValues.dateOfResolution && <span className="text-danger">*</span>}
                                                        </p>
                                                    </label>
                                                    <input
                                                        value={defaultValues?.start_date_of_treatment}
                                                        className="custminputbml selectTag"
                                                        id="start_date_of_treatment"
                                                        type="date"
                                                        placeholder="Enter Start Date"
                                                        aria-placeholder="#D4D4D4"
                                                        style={{ padding: "16px 12px", width: "340px" }}
                                                        onChange={handleStartDateChange}
                                                    />
                                                </div>
                                            )}



                                            {/* End Date input */}
                                            {flag !== true && (
                                                <div className="start-end-date">
                                                    <label htmlFor="endDate" className="custm_label_fw">
                                                        <p className="adverse-auto">Treatment End Date
                                                        {defaultValues.dateOfResolution && <span className="text-danger">*</span>}
                                                        </p>
                                                    </label>
                                                    <input
                                                        value={defaultValues?.end_date_of_treatment}
                                                        className="custminputbml selectTag"
                                                        id="end_date_of_treatment"
                                                        type="date"
                                                        placeholder="Enter End Date"
                                                        aria-placeholder="#D4D4D4"
                                                        style={{ padding: "16px 12px", width: "340px" }}
                                                        onChange={handleEndDateChange}
                                                        min={defaultValues.start_date_of_treatment} // Set minimum date based on Start Date
                                                    />
                                                </div>
                                            )}
                                        </div>











                                        {/* ////////////////////// */}
                                        {eventDtls?.serious_adverse_event_name ?
                                            <Row className="d-flex align-items-center">

                                                <Col>
                                                    <label htmlFor="lastName">
                                                        Serious adverse event criteria
                                                    </label>
                                                </Col>
                                                <Col>
                                                    <span>
                                                        <button className="red_btn advesre-serious" > {eventDtls?.serious_adverse_event_name}</button>
                                                    </span>
                                                </Col>
                                            </Row>

                                            :
                                            <div className="text-start d-flex flex-column justify-content-between" disabled={disableFields}>
                                                <Row className='mt-0 '>
                                                    <div className="d-block d-md-flex justify-content-between my-0 my-md-3 my-xxl-3 searchNselectmbl ">
                                                        <Col>
                                                            <label htmlFor="search_block">Serious Adverse Criteria<span className="text-danger"></span></label></Col>
                                                        <Col>
                                                            <div className="search_block" id='search_block' >
                                                                <div className="orange_btn cutm_btn_pdng" onClick={handleDropDown} style={{ width: "350px", padding: "12px 14px" }}
                                                                > {btnTitle.length > 30 ? btnTitle.slice(0, 30) + "..." : btnTitle || 'Select Adverse Criteria'}
                                                                    <img src="./images/icons/selectarrow.svg" alt="" />
                                                                </div>
                                                                {showPopup && <div className="search_main" onBlur={() => {
                                                                    setTimeout(() => {
                                                                        if (showPopup) {
                                                                            setShowPopup(false)
                                                                        }
                                                                    }, 200)
                                                                }}>
                                                                    <div className='drop_down_for_search'>
                                                                        <input
                                                                            type="text"
                                                                            className=""
                                                                            autoFocus
                                                                            value={searchTerm}
                                                                            disabled={disableFields}
                                                                            onChange={handleSearch}
                                                                            placeholder="Search..."
                                                                        />
                                                                        <img className='sasd' src="./images/icons/search.svg" alt="" />
                                                                        <div className="eventlist_items" disabled={disableFields}>
                                                                            {saEvents &&
                                                                                saEvents.filter(i => {
                                                                                    const event = i.serious_adverse_event_name || '';
                                                                                    return event.toLowerCase().includes((searchTerm || '').toLowerCase())
                                                                                }).map((i, index) => {

                                                                                    return (
                                                                                        <ul className='aelistdropdown' key={index}>
                                                                                            <li className={`${i.serious_adverse_event_name === btnTitle ? 'selectedOption' : ''}`} onClick={() => handleOption(i)}
                                                                                            >{i.serious_adverse_event_name || 'Select Adverse Criteria'}</li>
                                                                                        </ul>
                                                                                    )
                                                                                })}
                                                                        </div>
                                                                    </div>
                                                                </div>}
                                                            </div>
                                                        </Col>
                                                    </div>
                                                </Row>
                                            </div>
                                        }
                                        {eventDtls?.study_aebank_event_title !== null && <Row className="d-flex align-items-center">
                                            <div className="col-md col-sm-12 pe-lg-0">
                                                <label htmlFor="lastName">
                                                    Adverse event
                                                </label>
                                            </div>
                                            <div className="col-md col-sm-12 ps-md-0">
                                                <span>
                                                    <button className="orange_btn aebuttoncls advesre-serious"                                    
                                                    > 
                                                    {eventDtls?.study_aebank_event_title}
                                                    </button>
                                                </span>
                                            </div>
                                        </Row>}
                                        <div className="advEventGroup">
                                            <div className="p-0 p-md-4 p-xxl-4 bg-light rounded eventClassificationDivUpdateAE">
                                                <div className="custm-radio-styl reviewlist">
                                                    {((eventDtls?.study_case_definition == EVENT_CLASSIFICATION_AESI) || (eventDtls?.study_case_definition == EVENT_CLASSIFICATION_OTHER)) && (
                                                        <div className="reviewaetilte">
                                                            <div className="custm-radio-styl ">
                                                                <label
                                                                    htmlFor="notmetcase"
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "start",
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        id="notmetcase"
                                                                        checked
                                                                        style={{ width: "20px" }}
                                                                    />
                                                                    <span style={{ marginLeft: "10px" }}>
                                                                        <div className="custm-radio-styl">
                                                                            {eventDtls?.study_case_definition === EVENT_CLASSIFICATION_AESI
                                                                                ? 'Adverse Event of Special Interest'
                                                                                : eventDtls?.study_case_definition === EVENT_CLASSIFICATION_OTHER
                                                                                    ? 'Other'
                                                                                    : ''}
                                                                        </div>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {!disableFields && eventDtls?.input_notes_aesi_others !== null &&
                                                        <div>
                                                            <input
                                                                value={notesChange}
                                                                id="Treatment"
                                                                type="text"
                                                                className="border py-3 px-2 rounded w-100"
                                                                onChange={handleNotesChange}
                                                                style={{ marginTop: "12px", padding: "12px", height: "60px" }}
                                                            />
                                                        </div>
                                                    }
                                                    {disableFields ?
                                                        <div className="subtext">
                                                            <img src="./images/icons/checkedbox.svg" alt="" />
                                                            <span>{cleanText}</span>
                                                        </div>

                                                        : eventDtls !== "" ? (
                                                            <div className="advEventGroup">
                                                                <div className="p-2 bg-light rounded eventClassificationDivUpdateAE">
                                                                    {eventDtls?.study_case_definition === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? (
                                                                        <div className="accordianClass">
                                                                            <BrightonCaseUpdateAE handleReset={handleReset} radioValue={radioValue} handleRadioBtn={handleRadioBtn} radioReset={radioReset} getEventDescId={getEventDescId} />
                                                                        </div>

                                                                    ) : eventDtls?.study_case_definition === EVENT_CLASSIFICATION_GRADE_CTCAE ? (
                                                                        <Accordion >
                                                                            <GradeCaseUpdateAE handleReset={handleReset} radioValue={radioValue} handleRadioBtn={handleRadioBtn} radioReset={radioReset} getEventDescId={getEventDescId} />
                                                                        </Accordion>
                                                                    ) : eventDtls?.study_case_definition === EVENT_CLASSIFICATION_AESI ?
                                                                        <Accordion >
                                                                            <div className="fs-6" dangerouslySetInnerHTML={{ __html: getStudyAeDtls && getStudyAeDtls[0]?.other_case?.study_aesi_description.replace(/(?:\r\n|\r|\n)/g, '<br>') }}></div>
                                                                        </Accordion>
                                                                        : (
                                                                            ""
                                                                        )}
                                                                </div>
                                                            </div>
                                                        ) : null}

                                                </div>
                                            </div>
                                        </div>

                                        {/*eventDtls?.any_treatment_given !== '' && eventDtls?.any_treatment_given !== null &&
                                        <div>
                                            <label htmlFor="Treatment" className="fw-bold fs-6">Treatment Given</label>
                                            <input
                                                value={eventDtls?.any_treatment_given}
                                                className="border py-3 px-2 rounded w-100"
                                                id="Treatment Given"
                                                placeholder="Enter Treatment Given"
                                                disabled
                                            />
                                        </div>
                                                                */}
                                        {reviewerComments && reviewerComments?.filter(i => i.user_persona === PRINCIPAL_INVESTIGATOR).length > 0 &&
                                            <div>
                                                <label htmlFor="Treatment" className="fw-bold fs-6">Treatment Given</label>
                                                <div
                                                    className="border py-3 px-2 rounded w-100"

                                                >
                                                    {
                                                        reviewerComments && reviewerComments?.map((i, index) => {
                                                            return (
                                                                i.user_persona == PRINCIPAL_INVESTIGATOR ?
                                                                    <div className="d-flexflex-column">
                                                                        <div className="d-flex" style={{marginLeft:"15px"}}>
                                                                            <li></li>
                                                                            <div>{i.comment.charAt(0).toUpperCase() + i.comment.slice(1)}</div>

                                                                        </div>
                                                                        <p className=" updateae_cmnt_date">
                                                                            Treated On: {moment(i.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                                                                        </p>
                                                                    </div>
                                                                    : "")
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        }

                                        <div className={`${disableFields ? 'd-none' : ''}`}>
                                            <label htmlFor="Treatment" className="fw-bold fs-6">Comments</label>
                                            <input
                                                className="border py-3 px-2 rounded w-100"
                                                id="Treatment Given"
                                                placeholder="Enter Comments"
                                                onChange={handleTreatment}
                                            />
                                        </div>
                                       
                                        <div>
  <label htmlFor="attachment" className="fw-bold fs-6">
    Attachments
  </label>
  {eventDtls?.documents?.length > 0 ? (
    <div style={{ width: "340px" }}>
      {eventDtls?.documents?.map((document) => {
        const fileExtension = (document.document_name || '').split('.').pop().toLowerCase();
        let icon = getIcon(fileExtension);
        extensions = fileExtension;
        return (
          <div key={document.document_id} className="card my-custom-class">
            <div className="d-flex flex-row justify-content-between">
              <p className="col-10" title={document.document_name ? document.document_name : ''}>
                {document.document_name
                  ? document.document_name.length > 30
                    ? `${document.document_name.slice(0, 30)}...`
                    : document.document_name
                  : ''}
              </p>
              <img
                height="30px"
                width="50px"
                src={icon}
                alt=""
                title="Click on the icon to download the file"
                onClick={() => {
                   downloadFile(document.image_url,document.document_type,document.document_name)
                }}
                style={{ cursor: "pointer" }}
                />
            </div>
          </div>
        );
      })}
    </div>
  ) : (
    <p className="mb-0">No documents found</p>
  )}

</div>







                                        {!disableFields && <div>
                                            <span
                                                style={{ display: "flex", alignContent: "start" }}
                                            >
                                                <label htmlFor="file-input-label">Attach files</label>
                                            </span>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    marginTop: "20px",
                                                }}
                                            >
                                                <div
                                                    style={{ width: "500px", alignItems: "center" }}
                                                    className='subjreg_drop_zone'
                                                    id="drop-area"
                                                // onDrop={handleDrop}
                                                // onDragOver={handleDragOver}
                                                >
                                                    <div className="upload-icon" style={{}}>
                                                        <img
                                                            style={{
                                                                height: "100px",
                                                                margin: "6px",
                                                                paddingLeft: "5px",
                                                            }}
                                                            src="./images/icons/Upload.svg"
                                                            alt=""
                                                        />

                                                        <input
                                                            type="file"
                                                            id="file-input"
                                                            multiple
                                                            onChange={handleFileUpload}
                                                            disabled={fileNames.length >= 3 ? true : false}
                                                            accept=".pdf, .ppt, .txt, .docx, .doc, .xls, .csv, .jpeg, .jpg, .png"
                                                        />
                                                        <label
                                                            htmlFor="file-input"
                                                            className=""
                                                        >
                                                            <span className="gray_btn px-4" style={{ opacity: fileNames.length >= 3 ? "50%" : '' }}>Browse Files</span>
                                                        </label>
                                                        <p  >(PDF, PPT, TXT, DOCX, DOC, XLS, CSV, JPEG, JPG, PNG)</p>
                                                    </div>
                                                    <div id="file-list" style={{ margin: "10px" }}>
                                                        {fileNames.map((fileName, index) => (
                                                            <div key={fileName} className="file-container">
                                                                <div>{fileName}</div>
                                                                {/* <button className="close-icon" onClick={() => handleRemoveFile(index)}>
                                    X
                                  </button> */}
                                                                <span className='close-icon' style={{ color: 'red' }} title='Click on this to delete the file' onClick={() => handleRemoveFile(index)}>✕</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}








                                    </Col>
                                </div>
                                <div className="registrationStepsFooter" >
                                    <button className="white_btn white_btn_back px-md-4 white_btn_mbl" onClick={handleBack}>
                                        Back
                                    </button>

                                    {!disableFields ?
                                       <>
                                        <button
                                            id={'update'}
                                            className="red_btn red_btn_mbl"
                                            onClick={handleUpdate}
                                            disabled={
                                                // disableFields || 
                                                defaultValues.causality_id === '' ||
                                                defaultValues.outcome_id === "" ||
                                                defaultValues.action_taken_for_adverse_event_id === "" ||
                                                defaultValues?.start_date_of_treatment == "" ||
                                                defaultValues?.end_date_of_treatment == "" || 
                                                defaultValues.action_taken_id === "" ||
                                                (buttonDisable && defaultValues.start_date_of_treatment == null) ||
                                                (buttonDisable && defaultValues.end_date_of_treatment ==  null) ||


                                                defaultValues.dateOfResolution !== "" && defaultValues?.start_date_of_treatment == '' ||
                                                defaultValues.dateOfResolution !== "" && defaultValues?.end_date_of_treatment == '' ||



                                                defaultValues.dateOfOnset == "" ||
                                                defaultValues.timeOfOnset == "" ||
                                                defaultValues.timeOfResolution == ""}
                                        >
                                            Update
                                        </button> 
                                        {loader && <Loader />}
                                          </>                             
                                        : ""}         
                                </div>
                            </Row>
                        </Container>
                    </div>
                    <PopUpModal
                        handleClose={handleClosePopup}
                        open={open}
                        title={"Success!"}
                        msg={"Adverse event updated successfully!"}
                        close={"Close"}
                        actionbtn={"Done"}
                        onConfirm={handleConfirm}
                    />
                </div>
            }
        </>
    );
};
export default UpdateAEDetails;